export enum AppRoute {
  Root = '/',
  Index = '/am',
  PastDueList = '/am/past-due-list',
  ActivityLog = '/am/activity-log',
  Customer = '/am/customer',
  CustomerUpdate = '/customer/update',
  Dashboard = '/dashboard',
  StoreManagement = '/storemgmt/lookupstore',
  TakePayment = '/payment1/paymentinformation',
  CustomerAggrement = '/agreement/info/details',
}
